import React, { useMemo, useState, Suspense, lazy } from 'react';
import { CssBaseline, Container, ThemeProvider, CircularProgress, createTheme } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import PrivateRoute from './utils/PrivateRoute';
import getDesignTokens from './theme';
import BreadcrumbsNav from './components/BreadcrumbsNav';

const Login = lazy(() => import('./components/Auth/Login'));
const Register = lazy(() => import('./components/Auth/Register'));
const Dashboard = lazy(() => import('./components/Dashboard/Dashboard'));
const CreateCampaign = lazy(() => import('./components/Campaign/CreateCampaign'));
const CampaignDetails = lazy(() => import('./components/Campaign/CampaignDetails'));

function App() {
  if(!localStorage.mode){
    localStorage.mode = 'light'
  }
  const [mode, setMode] = useState(localStorage.mode);

  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  const toggleTheme = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
    localStorage.mode = localStorage.mode === 'light' ? 'dark' : 'light'
  };

  

  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Navbar toggleTheme={toggleTheme} />
          <Container>
            <BreadcrumbsNav />
            <Suspense
              fallback={
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                  <CircularProgress />
                </div>
              }
            >
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                <Route path="/dashboard" element={<PrivateRoute element={Dashboard} />} />
                <Route path="/dashboard/create" element={<PrivateRoute element={CreateCampaign} />} />
                <Route path="/dashboard/:campaignId" element={<PrivateRoute element={CampaignDetails} />} />

                <Route path="*" element={<PrivateRoute element={Dashboard} />} />
              </Routes>
            </Suspense>
          </Container>
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;